module.exports = {
        srcSet: __webpack_public_path__ + "6ff452ad18871e19-57.webp"+" 57w",
        images: [{path: __webpack_public_path__ + "6ff452ad18871e19-57.webp",width: 57,height: 40}],
        src: __webpack_public_path__ + "6ff452ad18871e19-57.webp",
        toString: function(){return __webpack_public_path__ + "6ff452ad18871e19-57.webp"},
        
        width: 57,
        height: 40
      }